var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var cio_datamodel = require("cio-datamodel");

var ModelAdderStateMachine = function (root, model, collection, userModel, dataManager, modelUploadSM, loadingModel) {
    var self = this;

    this.root = root;
    this.model = model;
    this.collection = collection;
    this.userModel = userModel;
    this.dataManager = dataManager;
    this.modelUploadSM = modelUploadSM;
    this.loadingModel = loadingModel;

    lib_core.StateMachine.call(self);

    this.lastAddedId = null;
    this.lastAddedType = null;
    this.lastAddedName = null;

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.NODE_MOUSE_DOWN && cEvent.data('type') == "3dmodel";
        },

        function(cEvent){
            var assetId = cEvent.data('content_server_id');
            var assetType = cEvent.data('type') || '3dmodel';
            var name = cEvent.data('name');
            var modelRef = new cio_datamodel.Model3DReference(assetType, assetId);
            modelRef.root = self.root;

            self.lastAddedId = assetId;
            self.lastAddedType = assetType;
            self.lastAddedName = name;

            var packageIsPrivate = self.root.asset.private;

            self.loadingModel.addLoad("CheckingModel", "Checking Model.");
            self.root.dataLoader.dataManager.getResource('3dmodel', assetId)
            .then(function(resource){
                self.loadingModel.removeLoad("CheckingModel");
                var modelIsPrivate = resource.private;

                if(!packageIsPrivate && modelIsPrivate){
                    self.model.makeModelPublicModalShown(true);
                } else {
                    self.addModelToData(modelRef, name);
                } 
            })
            .catch(function(err){
            // make sure thrown error goes to here
                self.loadingModel.removeLoad("CheckingModel");
            });
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.UI_TRAY_BUTTON && cEvent.data('button_id') == 'upload_step';
        },

        function(cEvent){
            self.modelUploadSM.showFileSelectWindow();
        } 
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.MAKE_MODEL_PUBLIC_AND_ADD;
        },

        function(cEvent){
            self.model.makeModelPublicModalShown(false);

            var assetId = self.lastAddedId;
            var assetType = self.lastAddedType;
            var name = self.lastAddedName;

            var modelRef = new cio_datamodel.Model3DReference(assetType, assetId);
            modelRef.root = self.root;

            self.loadingModel.addLoad("Publishing", "Publishing.");
            self.root.dataLoader.dataManager.publishResource("3dmodel", assetId, "publish", false)
            .then(function(){
                self.loadingModel.removeLoad("Publishing");
                return self.addModelToData(modelRef, name);
            })
            .catch(function(err){
            // make sure thrown error goes to here
                self.loadingModel.removeLoad("Publishing");
            });
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.CANCEL_ADD_MODEL;
        },

        function(cEvent){
            self.lastAddedId = null;
            self.lastAddedType = null;
            self.lastAddedName = null;

            self.model.makeModelPublicModalShown(false);
        }
    );
    


    // unused
    // self.addTransition("idle", "idle",
    //     function(cEvent){
    //         return cEvent.type() == lib_core.GuiEvents.TRAY_MODEL_PREVIEW_CLICKED;
    //     },

    //     function(cEvent){
    //         var model3dAsset = cEvent.data('model3dAsset');

    //         // self.model.model3dAsset = model3dAsset;

    //         // //return with error popup if files are missing
    //         // if(!(model3dAsset["obj"] && model3dAsset["mtl"])) {
    //         //     logError("Preview Error", new Error("Model preview error."), logError.criticality.MAJOR, "Model does not have any obj and material files.");
    //         //     return;
    //         // }

    //         // //load obj and mtl file from urls
    //         // var objData = self.dataManager.getResourceModel('obj', model3dAsset["id"], true);
    //         // var mtlData = self.dataManager.getResourceModel('mtl', model3dAsset["id"], true);
            
    //         // var mesh = new lib_geometry.TriangleMesh();
    //         // var model3d3JSObject = mesh.getObjWithMaterial(objData, mtlData);
    //         // model3d3JSObject.matrixAutoUpdate = false;
            
    //         self.model.model3d3JSObject(null);
    //     }
    // );
};

lib_core.inherit(ModelAdderStateMachine, lib_core.StateMachine);
module.exports = ModelAdderStateMachine;

ModelAdderStateMachine.prototype.addModelToData = function(modelRef, name){
    var self = this;
    self.loadingModel.addLoad("GeomertryLoad", "Loading 3D model...");

    return modelRef.calculateGeometryInfo()
       .then(function( ){
           
           self.root.rec();

           if(self.root.data.ipcParametricData()) {
                self.root.data.isIPCDataAnd3DModelOutOfSync(true);
                self.root.data.is3dModelUploadedManually(true);
           }

           self.root.data.model3d(modelRef);
           self.root.stopRec();

           self.loadingModel.removeLoad("GeomertryLoad");

           self.lastAddedId = null;
           self.lastAddedType = null;
           self.lastAddedName = null;

       })
       .catch(function(reason){
            self.loadingModel.removeLoad("GeomertryLoad");
            modelRef.getResource()
            .then((res)=>{
                console.log("this model has no obj")
                console.log(res);
            })
            var err = new Error("Model add failed, '"+name+"' could not be built because: " + reason);
            logError("Model Adder", err, logError.criticality.MAJOR, "This model appears to be corrupted.");
            throw err;
       });
}

